import { Tab } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegCheckCircle } from 'react-icons/fa';
import { HiOutlineDocumentDuplicate, HiOutlineSparkles } from 'react-icons/hi';
import { MdErrorOutline } from 'react-icons/md';
import { RiDeleteBinLine } from 'react-icons/ri';

import { BlobFilter } from '@/util/types';

export enum DOCUMENT_STATUS {
  ANALYZED = 'ANALYZED',
  NOT_ANALYZED = 'NOT_ANALYZED',
  DUPLICATE = 'DUPLICATE',
  CORRUPTED = 'CORRUPTED',
  SUGGESTION = 'SUGGESTION',
}

export const mapStatusToText = (value: BlobFilter) => {
  switch (value) {
    case BlobFilter.PARSED:
      return {
        icon: FaRegCheckCircle,
        text: DOCUMENT_STATUS.ANALYZED,
      };
    case BlobFilter.DUPLICATE:
      return {
        icon: HiOutlineDocumentDuplicate,
        text: DOCUMENT_STATUS.DUPLICATE,
      };
    case BlobFilter.UNPARSED:
      return {
        icon: RiDeleteBinLine,
        text: DOCUMENT_STATUS.NOT_ANALYZED,
      };
    case BlobFilter.CORRUPTED:
      return {
        icon: MdErrorOutline,
        text: DOCUMENT_STATUS.CORRUPTED,
      };
    case BlobFilter.SUGGESTION:
      return {
        icon: HiOutlineSparkles,
        text: DOCUMENT_STATUS.SUGGESTION,
      };
  }
};

interface InsightDocumentTabsProps {
  onClick?: () => void;
  keys: BlobFilter[];
  selectedTab: BlobFilter;
  handleTabClick: (tab: BlobFilter) => void;
  blobStatusCount: Record<string, number>;
}

export const InsightDocumentTabs: FC<InsightDocumentTabsProps> = ({
  onClick,
  keys,
  selectedTab,
  handleTabClick,
  blobStatusCount,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {keys.map((tab: BlobFilter) => (
        <Tab
          key={tab}
          label={t(`document-list.${mapStatusToText(tab)?.text?.toLowerCase()}`)}
          selected={selectedTab === tab}
          onClick={() => {
            onClick?.();
            handleTabClick(tab);
          }}
          count={blobStatusCount[tab?.toLowerCase()]}
          icon={mapStatusToText(tab)?.icon}
        />
      ))}
    </>
  );
};
